import styled from 'styled-components';

export const IconButton = styled.button`
  display: flex;
  background: none;
  border: none;
  padding: 8px;
  margin-right: 8px;
  cursor: pointer;
`;
